import React, { useState, useEffect, Suspense, useRef } from "react";
import { Image, Container, Row, Col, Dropdown } from "react-bootstrap";
import parser from "html-react-parser";
import { Link } from 'react-router-dom';
import "./index.css";

const Footer = (props) => {
  const ref = useRef();
  const [isIntersecting, setIntersecting] = useState(false);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [data, setData] = useState(null);
  const isSwmcDomain = () => {
    const currentUrl = window.location.href;
    return currentUrl.includes('swmc.com');
  };
  const Footerjson = isSwmcDomain() ? "swmc-footer.json" : "footer.json";
  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch(process.env.REACT_APP_CDN_URL + "eaimortgage/jsons/" + Footerjson);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const jsonData = await response.json();

        if (isSwmcDomain()) {
          jsonData.footerText = jsonData.footerText.map(paragraph => {
            if (paragraph.text?.includes("This site is not authorized by the New York State Department of Financial Services. No mortgage solicitation activity or loan applications for properties located in the State of New York can be facilitated through this site.")) {
              return {
                ...paragraph,
                text: "",
                linkText: "",
                suffixText: "Please <a href='https://www.swmc.com/evolutionaimortgage/Txdis' target='_blank'>Click Here</a> to view Texas Complaint Notice and Servicing Disclosure"
              };
            }
            return paragraph;
          });
        }

        // Replace the placeholder with the current year
        jsonData.footerText = jsonData.footerText.map(paragraph => {
          if (paragraph.text) {
            return {
              ...paragraph,
              text: paragraph.text.replace("YEAR_PLACEHOLDER", new Date().getFullYear())
            };
          }
          return paragraph;
        });

        setData(jsonData);

      } catch (error) {
        console.error("Error fetching footer data:", error);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (ref.current) {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          setIntersecting(entry.isIntersecting);
          observer.disconnect();
        }
      });
      observer.observe(ref.current);

      return () => {
        observer.disconnect();
      };
    }
  }, [data]);

  if (!data) {
    return null;
  }

  return (
    <footer className="footer">
      <Container>
        <div className="footer-logo">
          <Link to="/">
            <Image src={process.env.REACT_APP_CDN + data.logo} alt="EvolutionAI Logo" />
          </Link>
        </div>
        <div className="footer-top">
          <div className="footer-links">
          {data.links.map((link, index) => {
              if (link.dropdown && link.dropdown.length > 0) {
                return (
                  <Dropdown key={index} className="footer-dropdown">
                    <Dropdown.Toggle variant="link" className="footer-dropdown-toggle">
                      {link.text}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {link.dropdown.map((sublink, subIndex) => (
                        <Dropdown.Item as={Link} key={subIndex} to={sublink.url} target={sublink.url==="https://www.swmc.com/blog/" || sublink.url==="https://www.swmc.com/angelai/calculators" ? "_blank" : "_self"} rel="noopener noreferrer">
                          {sublink.text}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                );
              } else if (link.text === "ANGELAI") {
                return (
                  <a key={index} href={link.url} target="_blank" rel="noopener noreferrer">
                    {link.text}
                  </a>
                );
              } else {
                return (
                  <Link key={index} to={link.url}>
                    {link.text}
                  </Link>
                );
              }
            })}
          </div>
          <div className="footer-social">
            {data.socialMediaIcons.map((icon, index) => (
              <a key={index} href={icon.url} target="_blank" rel="noopener noreferrer">
                <Image src={process.env.REACT_APP_CDN + "evolutionai/images/" + icon.imgPath} alt={icon.imgPath.split("/").pop().split(".")[0]} title={icon.title} className="footer-social-icon" />
              </a>
            ))}
          </div>
        </div>
        <div className="footer-horizontal-line"></div>
        <div className="footer-text">
          {data.footerText.map((paragraph, index) => (
            <p key={index}>
              {paragraph.text && !paragraph.links && parser(paragraph.text)}
              {paragraph.linkText && (
                <Link
                  to={paragraph.linkUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {paragraph.linkText}
                </Link>
              )}
              {paragraph.suffixText && parser(paragraph.suffixText)}
              {paragraph.links && paragraph.links.map((link, idx) => (
                <React.Fragment key={idx}>
                  {idx > 0 && " - "}
                  <Link
                    to={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {link.text}
                  </Link>
                </React.Fragment>
              ))}
            </p>
          ))}
        </div>

        <div className="footer-awards">
          <Row className="footer-logo-section">
            <Col
              lg={12}
              xl={12}
              sm={12}
              md={8}
              xs={12}
              className="coloflogo"
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  justifyContent: "center",
                }}
                className="mobilelog"
              >
                <div>
                  <a
                    href={data.companyAwards.bestinBusiness.url}
                    target="_blank"
                    rel="noreferrer"
                    title={
                      data.companyAwards.bestinBusiness.title
                    }
                    aria-label={
                      data.companyAwards.bestinBusiness.title
                    }
                  >
                    <img
                      src={
                        data.companyAwards.bestinBusiness.imgPath
                      }
                      width="1480px"
                      height="1584px"
                      className="bestbixnew"
                      alt={
                        data.companyAwards.bestinBusiness.alt
                      }
                      title={
                        data.companyAwards.bestinBusiness.title
                      }
                      loading="lazy"
                    />
                  </a>
                </div>
                <div>
                  <img
                    src={
                      data.companyAwards.sunWestGreatPlaceToWork.imgPath
                    }
                    width="106px"
                    height="150px"
                    className="GTP"
                    alt={
                      data.companyAwards.sunWestGreatPlaceToWork.alt
                    }

                    title={
                      data.companyAwards.sunWestGreatPlaceToWork.title
                    }
                    loading="lazy"
                  />
                </div>
                <div>
                  <a
                    href={data.companyAwards.fastcologo.url}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={data.companyAwards.fastcologo.title}

                  >
                    <img
                      src={
                        data.companyAwards.fastcologo.imgPath
                      }
                      width="989px"
                      height="946px"
                      className="top50new"
                      alt={
                        data.companyAwards.fastcologo.alt
                      }
                      title={
                        data.companyAwards.fastcologo.title
                      }
                      loading="lazy"
                    />
                  </a>
                </div>
                <div>
                  <a
                    href={data.companyAwards.bbbRating.url}
                    target="_blank"
                    rel="noreferrer"
                    title={data.companyAwards.bbbRating.title}
                    aria-label={data.companyAwards.bbbRating.title}
                  >
                    <img
                      src={data.companyAwards.bbbRating.imgPath}
                      width="194px"
                      height="95px"
                      className="bbbnew"
                      alt={data.companyAwards.bbbRating.alt}
                      loading="lazy"

                    />
                  </a>
                </div>
                <div>
                  <a
                    href={data.companyAwards.bcaRating.url}
                    target="_blank"
                    rel="noreferrer"
                    title={data.companyAwards.bcaRating.title}
                    aria-label={data.companyAwards.bcaRating.title}
                  >
                    <img
                      src={data.companyAwards.bcaRating.imgPath}
                      width="138px"
                      height="78px"
                      className="alliancenew"
                      alt={data.companyAwards.bcaRating.alt}
                      loading="lazy"
                    />
                  </a>
                </div>
                <div ref={ref} className="birdeyeContainernew">
                  {isIntersecting ? (
                    <Suspense fallback={<div>Loading...</div>}>
                      {!iframeLoaded && (
                        <div
                          style={{
                            width: "165px",
                            height: "113px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          Loading...
                        </div>
                      )}
                      <div style={{ display: iframeLoaded ? 'block' : 'none' }}>
                        <a
                          href={
                            data.companyAwards.birdEyeReviews.url
                          }
                          target="_blank"
                          rel="noreferrer"
                          aria-label={data.companyAwards.birdEyeReviews.title}
                        >
                          <iframe
                            name="bfiframe"
                            title="birdeye"
                            className="reviewIcon"
                            src={parser(
                              data.companyAwards.birdEyeReviews.iframeUrl
                            )}
                            id="bfpublish"
                            scrolling="no"
                            onLoad={() => setIframeLoaded(true)}
                            style={{
                              borderWidth: "0px",
                              display: "block",
                              overflow: "hidden",
                              frameborder: "0",
                              height: "75px",
                            }}
                          />
                        </a>
                        <p
                          style={{ textAlign: "center" }}
                          className="birdeye"
                        >
                          Powered by{" "}
                          <a
                            href={
                              data.companyAwards.birdEyeReviews.poweredByUrl
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            Birdeye
                          </a>
                        </p>
                      </div>
                    </Suspense>
                  ) : (
                    <div
                      style={{
                        width: "165px",
                        height: "113px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      Birdeye
                    </div>
                  )}
                </div>
                <div>
                  <a
                    href={data.companyAwards.forbesCouncils.url}
                    target="_blank"
                    rel="noreferrer"
                    title={
                      data.companyAwards.forbesCouncils.title
                    }
                  >
                    <img
                      src={
                        data.companyAwards.forbesCouncils.imgPath
                      }
                      width="160px"
                      height="133px"
                      className="fbciconnew"
                      alt={
                        data.companyAwards.forbesCouncils.alt
                      }
                      loading="lazy"
                    />
                  </a>
                </div>
                <div>
                  <img
                    src={
                      data.companyAwards.equalHousingOpportunity.imgPath
                    }
                    alt={
                      data.companyAwards.equalHousingOpportunity.alt
                    }
                    title={
                      data.companyAwards.equalHousingOpportunity.title
                    }
                    className="homiconnew img-fluid"
                    loading="lazy"
                  />
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={12} className="coloflogo">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
                className="mobilelog"
              >
                {/* Conditional rendering of Tacanew logo based on props */}
                {props.showequalOpprtunityLogo && (
                  <div>
                    <img
                      src={
                        data.companyAwards.equalOpportunityEmployer.imgPath
                      }
                      alt={
                        data.companyAwards.equalOpportunityEmployer.alt
                      }
                      title={
                        data.companyAwards.equalOpportunityEmployer.title
                      }
                      className="equalopprtunity img-fluid"
                      loading="lazy"

                    />
                  </div>
                )}

              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
